import { PLACES_SEARCH_OPTIONS } from './constants';

const PLACE_PREDICTION_TIMEOUT_MS = 5000;

export const isGooglePlacesLoaded = () => Boolean(window.google?.maps?.places);

export const getTopPlacePrediction = (text) =>
  new Promise((resolve, reject) => {
    if (!isGooglePlacesLoaded()) {
      reject(new Error('Google Places is not loaded'));
      return;
    }
    const { AutocompleteService, PlacesServiceStatus } =
      window.google.maps.places;
    // Google never calls back when its own scripts fail to load, so stop waiting.
    const timeoutId = setTimeout(
      () => reject(new Error('Google Places timed out')),
      PLACE_PREDICTION_TIMEOUT_MS
    );
    new AutocompleteService().getPlacePredictions(
      { ...PLACES_SEARCH_OPTIONS, input: text },
      (predictions, status) => {
        clearTimeout(timeoutId);
        if (status === PlacesServiceStatus.OK) {
          resolve(predictions[0]);
        } else if (status === PlacesServiceStatus.ZERO_RESULTS) {
          resolve(null);
        } else {
          reject(new Error(status));
        }
      }
    );
  });
